/* eslint-disable react/prefer-stateless-function */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import _ from 'lodash';

import GoodyList from './GoodyList';
import ControlButton from '../Shared/ControlButton';

import { setCollectedNewGoodiesAsync } from '../../../actions/collectedGoodies';
import { setShuffleAsync } from '../../../actions/activeGoodies';

class GoodyBag extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
		};

		this.getClassNames = this.getClassNames.bind(this);
		this.toggleBag = this.toggleBag.bind(this);
	}

	getClassNames() {
		return classnames('goody-bag', {
			'goody-bag--is-open': this.state.isOpen,
		});
	}

	toggleBag() {
		this.props.clearNewGoodies();

		// Wait so that the "new" class is removed before we knock the bag over.
		// Otherwise, the bag doesn't transition to fall over.
		setTimeout(() => {
			this.setState({ isOpen: !this.state.isOpen });
		}, 20);
	}

	render() {
		return (
			<div className={this.getClassNames()}>
				<ControlButton
					className="goody-bag"
					iconName="Bag"
					isActive={this.state.isOpen}
					hasNotification={this.props.hasNewGoodies && !this.state.isOpen}
					notificationMessage="New goodies!"
					label="Goodies"
					callback={this.toggleBag}
				/>
				<GoodyList isOpen={this.state.isOpen} />
				<ControlButton
					shuffle
					isActive={this.props.shuffleIsActive}
					callback={this.props.setShuffle}
				/>
			</div>
		);
	}
}

GoodyBag.propTypes = {
	clearNewGoodies: PropTypes.func.isRequired,
	hasNewGoodies: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
	hasNewGoodies: !_.isEmpty(state.collectedGoodies.newItems),
	shuffleIsActive: state.activeGoodies.shuffle,
});

const mapDispatchToProps = dispatch => ({
	clearNewGoodies: () => {
		dispatch(setCollectedNewGoodiesAsync([]));
	},
	setShuffle: () => {
		dispatch(setShuffleAsync());
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(GoodyBag);



// WEBPACK FOOTER //
// ./src/components/Extension/GoodyBag/index.js